import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { SimpleTabs } from 'components';
import { Access } from './access';
import { SingleResourceHeader } from './singleResourceHeader';
import { resourceTabsLabels } from './constants';
import { FindSuccessItem, PermissionsList, RolePermission } from 'utils';
import { httpRequestsOnSuccessActions, resourceActions } from 'store';
import { ResourceFilesComponent } from './files';

const ACTION_TYPE = 'EDIT_RESOURCE_ACCESS';

export const SingleResource = () => {
  const [disabled, setDisabled] = useState(true);
  const [selectedList, setSelectedList] = useState({
    upload: [],
    download: [],
    delete: [],
  });
  const { resourceById, resourceAccessList, resourceDocuments } = useSelector((state) => (
    {
      resourceById: state.resource.resourceById,
      resourceAccessList: state.resource.resourceAccessList,
      resourceDocuments: state.resource.resourceDocuments,
    }
  ));
  const params = useParams();
  const dispatch = useDispatch();
  const success = FindSuccessItem(ACTION_TYPE);


  useEffect(() => {
    dispatch(resourceActions.getResourceDocument(params?.id));
  }, []);

  // FOR ACCESS TAB
  useEffect(() => {
    if (resourceAccessList) {
      resetByDefault();
    }
  }, [resourceAccessList]);

  useEffect(() => {
    if (success) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      setDisabled(true);
    }
  }, [success]);

  // ACCESS TAB END

  // FOR ACCESS TAB

  const resetByDefault = () => {
    const initialSelection = {
      upload: resourceAccessList.filter(admin => admin.upload).map(admin => admin.adminId),
      download: resourceAccessList.filter(admin => admin.download).map(admin => admin.adminId),
      delete: resourceAccessList.filter(admin => admin.delete).map(admin => admin.adminId),
    };
    setSelectedList(initialSelection);
  };

  const handleCheck = (item, permissionType, selectType) => {
    setSelectedList(prev => {
      let updated = { ...prev };

      if (selectType === 'all') {
        const allSelected = resourceAccessList.every(admin => prev[permissionType].includes(admin.adminId));
        updated[permissionType] = allSelected
          ? []
          : resourceAccessList.map(admin => admin.adminId);
      } else {
        const alreadySelected = prev[permissionType].includes(item.adminId);

        updated[permissionType] = alreadySelected
          ? prev[permissionType].filter(id => id !== item.adminId)
          : [...prev[permissionType], item.adminId];
      }

      return updated;
    });
  };


  const generatePayload = () => {
    const changedAdminAccesses = resourceAccessList.map((admin) => {
      const adminId = admin.adminId;
      const original = {
        upload: !!admin.upload,
        download: !!admin.download,
        delete: !!admin.delete,
      };

      const current = {
        upload: selectedList.upload.includes(adminId),
        download: selectedList.download.includes(adminId),
        delete: selectedList.delete.includes(adminId),
      };
      const hasChanged = (
        original.upload !== current.upload ||
        original.download !== current.download ||
        original.delete !== current.delete
      );

      return hasChanged ? { id: admin?.id, adminId, userType: admin?.userType, ...current } : null;
    })
      .filter(Boolean);

    if (changedAdminAccesses.length === 0) return;

    const res = {
      adminAccesses: changedAdminAccesses,
    };

    dispatch(resourceActions.editResourceAccess(params?.id, res));
  };

// ACCESS TAB END

  const tabsContent = [
    {
      tabComponent: (
        <ResourceFilesComponent
          currentId={params?.id}
          onResource={'resource'}
          documents={resourceDocuments}
        />
      ),
      tab: 'Files',
    },
    RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
    {
      tabComponent: <Access selectedList={selectedList} disabled={disabled} handleCheck={handleCheck} />,
      tab: 'Access',
    },
  ];

  return (
    <>
      <div className='tab-box-wrapper'>
        <SimpleTabs
          classNameWrapper='single-resource-tabs-wrapper'
          head={
            <SingleResourceHeader
              generatePayload={generatePayload}
              resetByDefault={resetByDefault}
              disabled={disabled}
              setDisabled={setDisabled}
            />
          }
          defaultTab={'Files'}
          tabsLabels={resourceTabsLabels}
          tabsContent={tabsContent}
          position='static'
        />
      </div>
    </>
  );
};
